import { toast } from 'sonner';
import { antiFlashWhite, pink2, successTint } from '../../../../../../../web/styles/colors';
import { GuestEmailMode, IEventSurveyResponse, IRecipient } from '../../../../../../models/Api';
export { buildCustomPropertiesSchema } from '../../../../../../utils/validation';

export const areGuestNamesValid = ({ firstName, lastName }: { firstName?: string; lastName?: string }): boolean => {
	// If both are empty, it's valid
	if (!firstName && !lastName) return true;
	// Only one provided: invalid
	if (!firstName || !lastName) return false;
	// Both provided: check that trimmed values exist
	return !!firstName.trim() === !!lastName.trim();
};

export const getGuestEmailMode = (mode: GuestEmailMode | null | undefined, isPaidEvent: boolean): GuestEmailMode =>
	mode ?? (isPaidEvent ? GuestEmailMode.Optional : GuestEmailMode.Off);

export const getSurveyGuestEmailMode = (survey?: {
	attendeeOptions?: { guestEmailMode?: GuestEmailMode | null };
	isPaidEvent?: boolean;
}) => getGuestEmailMode(survey?.attendeeOptions?.guestEmailMode, Boolean(survey?.isPaidEvent));

// A guest with an email is a real guest even without a name: the email is what lets us follow up with them.
export const isIdentifiedGuest = (guest: IRecipient, guestEmailMode: GuestEmailMode) =>
	Boolean(
		(guest.firstName?.trim() && guest.lastName?.trim()) ||
			(guestEmailMode !== GuestEmailMode.Off && guest.email?.trim())
	);

/**
 * Trims a guest for submission and drops an email the event doesn't collect, which can linger in form state from a
 * response saved before the creator stopped asking.
 */
export const toSubmittedGuest = <T extends IRecipient>(guest: T, guestEmailMode: GuestEmailMode): T => ({
	...guest,
	firstName: guest.firstName?.trim(),
	lastName: guest.lastName?.trim(),
	email: guestEmailMode === GuestEmailMode.Off ? undefined : guest.email?.trim() || undefined,
});

export const getSubmittedHolderEmail = (email: string | undefined, guestEmailMode: GuestEmailMode) =>
	guestEmailMode === GuestEmailMode.Off ? undefined : email?.trim();

export const handleMutationSuccess = ({
	onResponseSubmitted,
	successMessage,
	data,
}: {
	onResponseSubmitted: (data: IEventSurveyResponse) => void;
	successMessage: string;
	data: IEventSurveyResponse;
}) => {
	toast.success(successMessage);
	onResponseSubmitted(data);
};

export const getRsvpBackground = (attending: boolean | null, IS_PAST_EVENT: boolean, EVENT_FULL: boolean): string => {
	if (attending && !IS_PAST_EVENT && !EVENT_FULL) return successTint;
	if (attending === false || IS_PAST_EVENT || EVENT_FULL) return pink2;
	return antiFlashWhite;
};
